<template>
  <div class="main-container container-xxl">
    <titulo-grande texto="Cursos" posicao="left" />

    <modal :tituloModal="textoBtnCadastro" @fecha_modal="fecha_modal" @hidden="fecha_modal"
      textoBtnChamada="Inserir Curso" tamanho_modal="modal-lg" @click_bt_modal="click_bt_modal" :exibe_botao="true">

      <template #default>
        <form @submit.prevent="register" enctype="multipart/form-data" id="cad_forma_pagamento">
          <fieldset>
            <InputText placeholder="" label="Nome do curso *" tamanho="sm" nome="titulo_curso" ref="titulo_curso"
              v-model="titulo_curso" />

            <InputSelect placeholder="" label="Eleitor *" api_link="access_list/list_select"
              primeiro_vazio="Selecione o tipo de acesso para o curso" tamanho="sm" name="tipo_acesso" ref="tipo_acesso"
              v-model="tipo_acesso" />

            <InputText placeholder="" tipo="file" label="Imagem de capa do curso *" tamanho="sm" nome="imagem_capa"
              ref="imagem_capa" v-model="imagem_capa" />

            <InputTextarea name="descricao_curso" class="form-control" v-model="descricao_curso" />

            <input type="submit" class="d-none" value="">
          </fieldset>
        </form>
      </template>
      <template #botaoPersonalizado>
        <fieldset>
          <button type="button" @click.prevent="register" class="btn btn-primary">Salvar
            <Spinner :visivel="false" id="loading" />
          </button>
        </fieldset>
      </template>
    </modal>

    <modal tituloModal="" @fecha_modal="fecha_modal" @hidden="fecha_modal" textoBtnChamada="" tamanho_modal="modal-md"
      :exibe_botao="false" id_modal="modal_delete">
      <template #default>
        <p>
          Ao deletar um curso, todas as aulas e arquivos associados também serão deletados.
        </p>
        <p>
          Tem certeza que deseja deletar o curso <strong>"{{ titulo_delete }}"</strong>?
        </p>

      </template>
      <template #botaoPersonalizado>
        <fieldset>
          <button type="button" @click.prevent="deletar" class="btn btn-danger"><i class="bi bi-trash3-fill"></i>
            Deletar
            <Spinner :visivel="false" id="loading" />
          </button>
        </fieldset>
      </template>
    </modal>

    <TabelaDatatable :dadosData="dadosData" dadosAjax="" :showPathImage="$api_link + 'download/img/'" :btnStatus="true"
      :btnEdit="true" :btnDelete="true" :ativa_placeholder="ativa_placeholder" :columns="colunas"
      @edit_status="edit_status" @edit_row="dados_editar"
      :btnLinkRota="{ rota: '/admin/cad_aulas_curso/', texto: 'Add aulas' }" @delete_row="deletar_dados"
      modal_target_delete="#modal_delete"></TabelaDatatable>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue';
import TituloGrande from '../../components/TituloGrande.vue'
import TabelaDatatable from '@/components/TabelaDatatable.vue';
import InputText from '@/components/form/InputText.vue';
import { AuthStore } from '@/stores/Auth';
import { api } from '@/services/api';
import { bloqueia_campos } from '@/assets/js/functions'
import { cadastrar, editar_status, deletar } from '@/assets/js/requests'
import { toastr } from '@/plugins/toast';
import InputTextarea from '../../components/form/InputTextarea.vue';
import InputSelect from '@/components/form/InputSelect.vue';

export default {
  components: { TituloGrande, Modal, TabelaDatatable, InputText, InputTextarea, InputSelect },
  name: 'CadCursos',
  data() {
    return {
      auth: AuthStore(),
      id_delete: Number,
      id_dados: null,
      titulo_delete: String,
      titulo_curso: '',
      tipo_acesso: '',
      descricao_curso: '',
      imagem_capa: '',
      dadosData: '',
      colunas: [
        { name: 'image', data: 'imagem_capa', title: 'Imagem de capa', width: '10%', height: '40px' },
        { data: 'titulo_curso', title: 'Título do curso', width: '40%' },
        { data: 'tipo_acesso', title: 'Tipo de acesso', width: '40%' },
        { name: 'acoes', data: 'status', title: 'Ações', width: '10%' },
      ],
      textoBtnCadastro: 'Cadastro de curso',
      ativa_placeholder: Boolean,
    }
  },
  mounted() {
    this.listagemTabela();
  },
  methods: {
    async listagemTabela() {
      this.ativa_placeholder = true
      this.dadosData = await api.get('courses/list', { Authorization: this.auth.token })
      this.ativa_placeholder = false
    },
    async register(e) {
      e.preventDefault();
      if (!this.titulo_curso) {
        toastr.alerta("Digite o nome do curso")
        return false;
      }
      const formu = document.querySelector("#cad_forma_pagamento")
      const dados = new FormData(formu)
      dados.append('descricao_curso', this.descricao_curso)
      if (this.id_dados > 0) {
        dados.append('id', this.id_dados)
      }
      const registro = await cadastrar('courses/register', dados);
      if (registro) {
        if (!this.id_dados) {
          this.limpa_campos()
        }
        this.listagemTabela()
      }
    },
    async edit_status(dados) {
      const edit = await editar_status('courses/change_status', dados);
      if (edit) {
        this.listagemTabela()
      } else {
        // this.$router.push('/login')
      }
    },
    async dados_editar(dados) {
      bloqueia_campos()
      var dadosEdit = await api.get('courses/list/' + dados.rowData.id, { Authorization: this.auth.token })

      this.id_dados = dados.rowData.id;
      this.titulo_curso = dadosEdit.titulo_curso;
      this.tipo_acesso = dadosEdit.tipo_acesso;
      this.descricao_curso = dadosEdit.descricao_curso;
      // this.imagem_capa = dadosEdit.imagem_capa;

      document.querySelector("#btn_modal_cadastrar").click()
      bloqueia_campos(false)
    },
    fecha_modal() {
      this.limpa_campos()
    },
    limpa_campos() {
      this.titulo_curso = '';
      this.tipo_acesso = '';
      this.descricao_curso = '';
      this.imagem_capa = '';
      this.id_dados = null;
    },
    click_bt_modal() {
      if (this.id_dados > 0) {
        this.textoBtnCadastro = 'Editando curso: ' + this.titulo_curso
      } else {
        this.textoBtnCadastro = 'Cadastrar curso'
      }
    },
    deletar_dados(dados) {
      this.id_delete = dados.rowData.id
      this.titulo_delete = dados.rowData.titulo_curso
    },
    async deletar() {
      const delet = await deletar('courses/delete', { id: this.id_delete });
      if (delet) {
        this.listagemTabela()
      }
    }
  },
}
</script>

<style></style>